// A section of a chat agent's system prompt that a surface rebuilds as every
// run starts: the surface's live state (Policy chat's current step), which
// changes between the person's messages. pi snapshots the system prompt at
// run start, so the section is stamped just before each `prompt` and
// `continue`, the way promptDate.js stamps today's date.
import { setSystemPrompt } from "./agentTranscript.js";

const SECTION_BLOCK = /\n*<page_context>[\s\S]*?<\/page_context>/;

export function replaceSurfaceSection(systemPrompt, section) {
    const prompt = String(systemPrompt || "");
    const block = section ? `<page_context>\n${section}\n</page_context>` : "";
    if (SECTION_BLOCK.test(prompt)) return prompt.replace(SECTION_BLOCK, block ? `\n\n${block}` : "");
    if (!block) return prompt;
    return prompt ? `${prompt}\n\n${block}` : block;
}

/// Stamps `section()` into the agent's system prompt now and as every run
/// starts. A failed context read prevents a run with stale settings.
export function stampSurfaceSection(agent, section) {
    const stamp = () => {
        const text = String(section() ?? "");
        setSystemPrompt(agent, replaceSurfaceSection(agent.state.systemPrompt, text));
    };
    stamp();
    for (const method of ["prompt", "continue"]) {
        const run = agent[method].bind(agent);
        agent[method] = (...args) => {
            stamp();
            return run(...args);
        };
    }
}
